import { render, staticRenderFns } from "./UserCreatorWidgetV2.vue?vue&type=template&id=315a0850&scoped=true"
import script from "./UserCreatorWidgetV2.vue?vue&type=script&lang=js"
export * from "./UserCreatorWidgetV2.vue?vue&type=script&lang=js"
import style0 from "./UserCreatorWidgetV2.vue?vue&type=style&index=0&id=315a0850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a0850",
  null
  
)

export default component.exports